<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">变更单号</label>
            <em class="weui-form-preview__value">{{ form.main.fc_code }}</em>
          </div>
        </div>
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">资产编号</label>
            <span class="weui-form-preview__value">{{ form.main.fa_code }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">资产名称</label>
            <span class="weui-form-preview__value">{{ form.main.fa_name }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">资产类别</label>
            <span class="weui-form-preview__value">{{ form.main.fa_class }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">规格型号</label>
            <span class="weui-form-preview__value">{{ form.main.fa_model }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">品牌</label>
            <span class="weui-form-preview__value">{{ form.main.fa_brand }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">增加方式</label>
            <span class="weui-form-preview__value">{{ form.main.fa_addway }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">折旧方法</label>
            <span class="weui-form-preview__value">{{ form.main.fa_deprway }}</span>
          </div>
        </div>
      </div>
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">原存放地址</label>
            <span class="weui-form-preview__value">{{ form.main.fc_depositaddr_old }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">新存放地址</label>
            <span class="weui-form-preview__value">{{ form.main.fc_depositaddr_new }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">原领用部门</label>
            <span class="weui-form-preview__value">{{ form.main.fc_deptname_old }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">新领用部门</label>
            <span class="weui-form-preview__value">{{ form.main.fc_deptname_new }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">原领用人</label>
            <span class="weui-form-preview__value">{{ form.main.fc_username_old }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">新领用人</label>
            <span class="weui-form-preview__value">{{ form.main.fc_username_new }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">原使用状态</label>
            <span class="weui-form-preview__value">{{ form.main.fc_usestauts_old }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">新使用状态</label>
            <span class="weui-form-preview__value">{{ form.main.fc_usestauts_new }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">申请人</label>
            <span class="weui-form-preview__value">{{ form.main.fc_applyname }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">变更人</label>
            <span class="weui-form-preview__value">{{ form.main.creatorName }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">审核人</label>
            <span class="weui-form-preview__value">{{ form.main.fc_auditman }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">变更原因</label>
            <span class="weui-form-preview__value">{{ form.main.fc_reason }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import process from "@/mixins/process.js";

export default {
  mixins: [process],
  data() {
    return {
      baseUrl: "/api/oa/fixedassetschange",
      codeField: "fc_code",
      statusField: "fc_statuscode",
      caller: "FixedAssetsChange"
    }
  } 
}
</script>